import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-configurable-link-list',
  templateUrl: './configurable_link_list.component.html',
  styleUrls: ['./configurable_link_list.component.scss']
})

export class ConfigurableLinkListComponent {

  @Output() linkClickedOutput = new EventEmitter<any>();
  @Output() deleteClickedOutput = new EventEmitter<any>();
  @Input() list:[
    {
      textContent:string,
      [key:string]:any
    }
  ];
  @Input() ParentComponent;
  public isEditor:boolean=false;

  divMouseEnter($event, item) {
    item.isHoveredOver = true;
  }
  divMouseLeave($event, item) {
    item.isHoveredOver = false;
  }
    divClicked($event, item) {
      var targetDiv:HTMLElement = $event.target;

      if(targetDiv instanceof HTMLAnchorElement) {
          //make sure this click event was not for the trashcan
          if(targetDiv.className && targetDiv.className.indexOf('cvt-icon-trash')>-1) {
              return;
          }
      }

      //assuming the normal behavior of this component is to execute cvent functions when the links are clicked
      //we don't want the default behavior of links to occur
      $event.preventDefault();


      for(let ctr=0; ctr<this.list.length; ctr++) {
        let config = this.list[ctr];
        config.isSelected = false;
      }
      item.isSelected = true;
      
      //pass the original click event in case it's needed
      this.linkClickedOutput.emit({$event:$event,item:item});
    }
    deleteClicked($event, item) {
      $event.preventDefault();
      this.deleteClickedOutput.emit({$event:$event,item:item});
    }
}
